import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RenderMarkdown } from 'MarkdownComponents';
import { ClickableText } from 'ClickableText';
import { SidebarBox } from './SidebarBox';
import '../locales/streamDashboard/streamDashboard-en.json';

type Props = {
    topics: string[];
    hasKeyTerms: boolean;

    // The key terms section reveals itself on a delay, so the link cannot scroll to it before then.
    keyTermsReady: boolean;
    onExploreKeyTerms: () => void;
    className?: string;
};

export const WhatYouWillLearnBox: FC<Props> = ({
    topics,
    hasKeyTerms,
    keyTermsReady,
    onExploreKeyTerms,
    className,
}) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!topics.length) return null;

    return (
        <SidebarBox caption={t('course_highlights')} className={className}>
            <ul className="list-disc !ps-6.25 text-sm">
                {topics.map(topic => (
                    <li key={topic}>
                        <RenderMarkdown>{topic}</RenderMarkdown>
                    </li>
                ))}
            </ul>
            {hasKeyTerms && (
                <ClickableText
                    onPress={onExploreKeyTerms}
                    disabled={!keyTermsReady}
                    color="primary"
                    underline="none"
                    weight="semibold"
                    className="mt-3.5 block w-full text-center text-sm max-md:hidden"
                >
                    {t('explore_key_terms')}
                </ClickableText>
            )}
        </SidebarBox>
    );
};
